@if (multiple) {
  <mat-checkbox
    (click)="handleClick($event)"
    [checked]="isChecked"
    [disabled]="isDisabled"
    [indeterminate]="isIndeterminate"
    [color]="isChecked ? 'primary' : 'accent'"
  >
    @if (!hideLabels) {
      <div class="mat-body">
        {{ label || "Select All" }}
      </div>
    }
  </mat-checkbox>
} @else {
  @if (!hideLabels) {
    <div class="mat-body mb-8">
      {{ label || "Select All" }}
    </div>
  }
}

<app-basic-user-selection-list
  [multiple]="multiple"
  (user)="handleUser($event)"
  [(users)]="users"
  (usersChange)="handleUsersChange($event)"
>
  <!-- #TODO Figure out how to project a template through this component -->
  @if (selectedLabelText) {
    <ng-template appSelected>
      <app-basic-label [text]="selectedLabelText"></app-basic-label>
    </ng-template>
  }
</app-basic-user-selection-list>
